import React, { createContext, useContext, useState, ReactNode, useEffect, useMemo } from "react";
import { TTargetTax } from "types/tax";
import { TTargetType } from "types/target-type";

interface LineItemContextProps {
  showMath: boolean;
  setShowMath: React.Dispatch<React.SetStateAction<boolean>>;
  taxTotal: number;
  setTaxTotal: React.Dispatch<React.SetStateAction<number>>;
  taxableProductTotal: number;
  setTaxableProductTotal: React.Dispatch<React.SetStateAction<number>>;
  taxes: TTargetTax[];
  setTaxes: React.Dispatch<React.SetStateAction<TTargetTax[]>>;
  taxHasBeenAdded: boolean;
  setTaxHasBeenAdded: React.Dispatch<React.SetStateAction<boolean>>;
  hasExistingTaxes: boolean;
  noTax: boolean;
}

const LineItemContext = createContext<LineItemContextProps | undefined>(undefined);

export const LineItemProvider = ({ children, type, noTax }: { children: ReactNode, type: TTargetType, noTax: boolean }) => {
  const [showMath, setShowMath] = useState(false);
  const [taxTotal, setTaxTotal] = useState(0);
  const [taxableProductTotal, setTaxableProductTotal] = useState(0);
  const [taxes, setTaxes] = useState<TTargetTax[]>([]);
  const [taxHasBeenAdded, setTaxHasBeenAdded] = useState(false);

  // // Calculate noTax based on type
  // const noTax = useMemo(() => {
  //   return type === "estimate_appt" || type === "group" || type === "project" || type === "request";
  // }, [type]);

  // Track if taxes already exist (computed from current taxes array)
  const hasExistingTaxes = useMemo(() => {
    return taxes.some(tax => tax.tax_type === "tax");
  }, [taxes]);

  useEffect(() => {
    if (taxHasBeenAdded) {
      const taxCount = taxes.filter(tax => tax.tax_type === "tax").length;
      if (taxCount === 0) {
        setTaxHasBeenAdded(false);
      }
    }
  }, [taxes, taxHasBeenAdded]);

  return (
    <LineItemContext.Provider value={{ showMath, setShowMath, taxTotal, setTaxTotal, taxableProductTotal, setTaxableProductTotal, taxes, setTaxes, taxHasBeenAdded, setTaxHasBeenAdded, hasExistingTaxes, noTax }}>
      {children}
    </LineItemContext.Provider>
  );
};

export const useLineItemContext = () => {
  const context = useContext(LineItemContext);
  if (!context) throw new Error("useLineItemContext must be used inside LineItemProvider");
  return context;
};
